import {Controller} from "@hotwired/stimulus";
import {useClickOutside} from "stimulus-use";

/**
 * Controller for managing flash messages that auto-hides
 * a message after a delay and hides on outside/inside clicks.
 *
 * Example usage:
 * .fm-flash{data: { controller: 'flash' }}
 *   - flash.each do |type, message|
 *     - klass = (type.to_sym == :notice) ? 'text-notice' : 'text-error'
 *     .flash-msg{class: klass, data: { flash_target: 'message' }}
 *       .flex.items-center= message
 *       .flash-close{data: { action: 'click->flash#close' }}= '✖'
 *
 * The default auto-close delay is 3.5 seconds.
 * Can be overridden with flash_auto_close_after_value.
 */

export default class extends Controller {
  static values = {
    autoCloseAfter: {type: Number, default: 3500}
  };

  connect() {
    super.connect();
    useClickOutside(this);

    setTimeout(() => {
      this.close();
    }, this.autoCloseAfterValue);
  }

  close() {
    this.element.remove();
  }

  clickOutside() {
    this.close();
  }
}